export default function isGoogleMapsLoaded() {
  if (typeof google === 'object' && typeof google.maps === 'object') {
    return true;
  } else {
    console.warn("Google Maps was not loaded");
    return false;
  }
}
